import { render } from "./guanyu_zheng.vue?vue&type=template&id=50de3e98&scoped=true"
import script from "./guanyu_zheng.vue?vue&type=script&lang=js"
export * from "./guanyu_zheng.vue?vue&type=script&lang=js"

import "./guanyu_zheng.vue?vue&type=style&index=0&id=50de3e98&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50de3e98"]])

export default __exports__